/**
 * Tactile confirmation for actions that directly change a player's hand.
 * Browsers that do not expose Vibration simply receive the visual feedback;
 * no game state ever depends on this API.
 */
export type HapticKind = 'tap' | 'snap' | 'success' | 'turn';

const patterns: Record<HapticKind, number | number[]> = {
  tap: 10,
  snap: 7,
  success: [10, 28, 18],
  /** A player who is not looking at the screen — sound off, phone face down
   *  between turns — has only this to notice it is their move. Deliberately
   *  distinct from `success` so the two are never confused by feel alone. */
  turn: [14, 60, 14],
};

export function haptic(kind: HapticKind): void {
  try {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    navigator.vibrate?.(patterns[kind]);
  } catch {
    // Vibration is deliberately best-effort: iOS, desktop and embedded
    // browsers commonly omit it.
  }
}
